import { B4, SH2, SH3 } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

const FeeHighlight = ({
  title,
  amount,
  titlePostfix,
  isJfsFlow,
}: {
  title?: string
  titlePostfix?: string
  amount?: string
  isJfsFlow?: boolean
}) => {
  return (
    <Pressable
      className={`border-grays-40 flex-1 ${
        isJfsFlow ? 'rounded-lg' : 'rounded-md'
      } border bg-white px-2 py-2 `}
    >
      {isJfsFlow ? (
        <>
          <B4
            style={{
              fontSize: 14,
            }}
            className={'text-grays-80'}
          >
            {title}
            {titlePostfix}
          </B4>
          <SH2
            style={{
              fontSize: 16,
            }}
          >
            {amount}
          </SH2>
        </>
      ) : (
        <>
          <B4 className={'text-grays-70'}>
            {title}
            {titlePostfix}
          </B4>
          <SH3>{amount}</SH3>
        </>
      )}
    </Pressable>
  )
}

export default FeeHighlight
